module.exports = __webpack_public_path__ + "static/img/bg1.61294cfa.svg";